import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import KerdesAsszociaciosListItemDto from './KerdesAsszociaciosListItemDto';
import LeirasTetelAsszociaciosListItemDto from './LeirasTetelAsszociaciosListItemDto';

export class AsszociaciosKerdesEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.sorszamTol = null;
		this.sorszamIg = null;
		this.alsorszamTol = null;
		this.alsorszamIg = null;
		this.subsorszamTol = null;
		this.subsorszamIg = null;
		this.csorszam = null;

		this.leiras = null;
		this.leirasPlaintext = null;

		this.feladatCsoport = null;

		this.kerdesAsszociacios = null;
		this.leirasTetelAsszociacios = null;
	}

	setup(props) {
		super.setup(props);
		this.sorszamTol = props.sorszamTol;
		this.sorszamIg = props.sorszamIg;
		this.alsorszamTol = props.alsorszamTol;
		this.alsorszamIg = props.alsorszamIg;
		this.subsorszamTol = props.subsorszamTol;
		this.subsorszamIg = props.subsorszamIg;
		this.csorszam = props.csorszam;

		this.leiras = props.leiras;
		this.leirasPlaintext = props.leirasPlaintext;

		this.feladatCsoport = props.feladatCsoport;

		this.kerdesAsszociacios = props.kerdesAsszociacios != null ? props.kerdesAsszociacios.map(d => new KerdesAsszociaciosListItemDto().setup(d)) : [];
		this.leirasTetelAsszociacios = props.leirasTetelAsszociacios != null ? props.leirasTetelAsszociacios.map(d => new LeirasTetelAsszociaciosListItemDto().setup(d)) : [];

		return this;
	}
}

export default AsszociaciosKerdesEditDto;
